import { buildQuery, getNewAuthToken, isTokenExpired } from '../utils';
import axios, { api } from '../utils/axios';
import { decrypt, encrypt } from '../utils/encodingdecoding';
import { errToast } from '../utils/helper';
import setAuthToken from '../utils/setAuthToken';
import { baseURL } from '../utils/url';
import swal from 'sweetalert';

export const Token_Generator = async () => {
	try {
		const fetchResponse = await fetch(baseURL + 'tokengenerator', {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		});
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};

export const Internal_Token = async (body) => {
	try {
		const fetchResponse = await fetch(baseURL + 'internaltoken', {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		});
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};

export const signin = async (token, data) => {
	try {
		const fetchResponse = await fetch(baseURL + 'signin', {
			method: 'POST',
			headers: {
				Authorization: 'Bearer ' + token,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		});
		const response = await fetchResponse.json();
		return response;
	} catch (error) {
		return error;
	}
};

export const signup = async (token, data) => {
	try {
		const fetchResponse = await fetch(baseURL + 'signup', {
			method: 'POST',
			headers: {
				Authorization: 'Bearer ' + token,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		});
		const response = await fetchResponse.json();
		return response;
	} catch (error) {
		return error;
	}
};

export const forgetPassword = async (token, data) => {
	try {
		const fetchResponse = await fetch(baseURL + 'forget', {
			method: 'POST',
			headers: {
				Authorization: 'Bearer ' + token,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			auth: (token, { type: 'bearer' }),
			body: JSON.stringify(data),
		});
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};

export const resetPassword = async (token, data) => {
	try {
		const fetchResponse = await fetch(baseURL + 'reset', {
			method: 'POST',
			headers: {
				Authorization: 'Bearer ' + token,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			auth: (token, { type: 'bearer' }),
			body: JSON.stringify(data),
		});
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};
export const adminsignin = async (token, data) => {
	try {
		const fetchResponse = await fetch(baseURL + 'signin', {
			method: 'POST',
			headers: {
				Authorization: 'Bearer ' + token,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		});
		fetchResponse
			.json()
			.then((res) => {
				if (res.message === 'Valid Login Details') {
					localStorage.setItem('token_rare', JSON.stringify(true));
					return res;
				} else {
				}
			})
			.catch(() => {
				return null;
			});
	} catch (error) {
		return error;
	}
};

export const signupConfirmation = async (token, id) => {
	try {
		const fetchResponse = await fetch(`${baseURL}confirmsignup?id=${id}`, {
			method: 'POST',
			headers: {
				Authorization: 'Bearer ' + token,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			auth: (token, { type: 'bearer' }),
		});
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};

export const merchantGiftCard = async (body) => {
	try {
		const fetchResponse = await fetch(`${baseURL}merchantGiftCard`, {
			method: 'POST',
			headers: {
				Authorization: 'Bearer ',
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		});
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};

export const getIndustry = async (token) => {
	try {
		const fetchResponse = await fetch(baseURL + 'getIndustry', {
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + token,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		});
		const response = await fetchResponse.json();
		return response;
	} catch (error) {
		return error;
	}
};

export const countryRegions = async (token) => {
	const valid = await isTokenExpired(token);
	try {
		if (!valid)
			await getNewAuthToken().then((res) => {
				localStorage.setItem('token_gen', JSON.stringify(res));
				token = res.access_token;
			});
		const fetchResponse = await fetch(baseURL + 'countryRegions', {
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + token,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		});
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};

export const updateCatCache = async (token) => {
	const valid = await isTokenExpired(token);
	try {
		if (!valid)
			await getNewAuthToken().then((res) => {
				localStorage.setItem('token_gen', JSON.stringify(res));
				token = res.access_token;
			});
		setAuthToken(token);
		const fetchResponse = await axios.get(`updateCatCache`);
		return fetchResponse?.data;
	} catch (error) {
		return error;
	}
};

export const giftCardOrder = async (token, body) => {
	const valid = await isTokenExpired(token);
	try {
		if (!valid)
			await getNewAuthToken().then((res) => {
				localStorage.setItem('token_gen', JSON.stringify(res));
				token = res.access_token;
			});
		const fetchResponse = await fetch(baseURL + 'giftCardOrder', {
			method: 'POST',
			headers: {
				Authorization: 'Bearer ' + token,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		});
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};

export const getGiftCardOrder = async (token) => {
	const valid = await isTokenExpired(token);
	try {
		if (!valid)
			await getNewAuthToken().then((res) => {
				localStorage.setItem('token_gen', JSON.stringify(res));
				token = res.access_token;
			});
		const fetchResponse = await fetch(baseURL + 'getGiftCardOrder', {
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + token,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			// body: JSON.stringify(body),
		});
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};

export const getSelectGiftCard = async (client) => {
	try {
		const fetchResponse = await fetch(
			`${baseURL}getSelectGiftCard?client=${client}`,
			{
				method: 'GET',
			},
		);
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};
export const getSelectedGiftCard = async (code) => {
	try {
		const fetchResponse = await fetch(
			`${baseURL}getSelectedGiftCard?code=${code}`,
			{
				method: 'GET',
			},
		);
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};
export const getAllGiftcard = async () => {
	try {
		const fetchResponse = await fetch(`${baseURL}getAllGiftcard`, {
			method: 'GET',
		});
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};

export const redeemMerchantWallet = async (token, point, body) => {
	const valid = await isTokenExpired(token);
	try {
		if (!valid)
			await getNewAuthToken().then((res) => {
				localStorage.setItem('token_gen', JSON.stringify(res));
				token = res.access_token;
			});
		const fetchResponse = await fetch(
			baseURL + `redeemMerchantWallet?point=${point}`,
			{
				method: 'POST',
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(body),
			},
		);
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};

export const refundMerchantWallet = async (token, id, body) => {
	const valid = await isTokenExpired(token);
	try {
		if (!valid)
			await getNewAuthToken().then((res) => {
				localStorage.setItem('token_gen', JSON.stringify(res));
				token = res.access_token;
			});
		const fetchResponse = await fetch(
			baseURL + `refundMerchantWallet?id=${id}`,
			{
				method: 'POST',
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(body),
			},
		);
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};

export const clientDetails = async (token) => {
	try {
		const fetchResponse = await fetch(baseURL + 'clientList', {
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + token,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
		});
		const response = await fetchResponse.json();
		return response;
	} catch (error) {
		return error;
	}
};

export const ClientDetailData = async (token, clientcode, body) => {
	try {
		const fetchResponse = await fetch(
			baseURL + `clientUpdate?clientcode=${clientcode}`,
			{
				method: 'POST',
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(body),
			},
		);
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};

export const getMerchantWallet = async (token, merchantId) => {
	try {
		const fetchResponse = await fetch(
			baseURL + 'walletReportData?merchantId=' + merchantId,
			{
				method: 'GET',
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			},
		);
		const response = await fetchResponse.json();
		return response;
	} catch (error) {
		return error;
	}
};

export const UpdateMerchantLimitData = async (
	token,
	id,
	value,
	description,
) => {
	try {
		const fetchResponse = await fetch(
			baseURL +
				`UpdateMerchantLimit?id=${id}&value=${value}&description=${description}`,
			{
				method: 'PUT',
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			},
		);
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};

export const redeemDeductWallet = async (token, id, value, description) => {
	const valid = await isTokenExpired(token);
	try {
		if (!valid)
			await getNewAuthToken().then((res) => {
				localStorage.setItem('token_gen1', JSON.stringify(res));
				token = res.access_token;
			});
		const fetchResponse = await fetch(
			baseURL +
				`deductWallet?id=${id}&value=${value}&description=${description}`,
			{
				method: 'POST',
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			},
		);
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};

export const giftCardUpdate = async (body) => {
	try {
		const fetchResponse = await fetch(`${baseURL}giftCardUpdate`, {
			method: 'POST',
			headers: {
				Authorization: 'Bearer ',
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		});
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};

export const createGiftCard = async (body) => {
	try {
		const fetchResponse = await fetch(`${baseURL}createGiftCard`, {
			method: 'POST',
			headers: {
				Authorization: 'Bearer ',
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		});
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};

export const sendEmail = async (token, body) => {
	try {
		const fetchResponse = await fetch(`${baseURL}sendGrid`, {
			method: 'POST',
			headers: {
				Authorization: 'Bearer ' + token,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		});
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};

export const regenerate = async (ref_no, vender_code) => {
	try {
		const fetchResponse = await fetch(
			baseURL + `regenerate?refno=${ref_no}&vendor_code=${vender_code}`,
			{
				method: 'GET',
				headers: {
					Authorization: 'Bearer ',
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			},
		);
		const response = await fetchResponse.json();
		return response;
	} catch (error) {
		return error;
	}
};

export const updateOrderList = async (token, body) => {
	try {
		const fetchResponse = await fetch(`${baseURL}updateOrderList`, {
			method: 'POST',
			headers: {
				Authorization: 'Bearer ' + token,
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		});
		return await fetchResponse.json();
	} catch (error) {
		return error;
	}
};

//fetch giftcards
export const getGiftcards = (formData) => {
	return async (dispatch, getState) => {
		try {
			const res = await api.get(buildQuery('getGiftcards', formData));
			return res?.data;
		} catch (err) {
			if (
				err?.response?.data.message === 'Not Found' &&
				err?.response?.status === 404
			) {
				swal({
					position: 'center',
					icon: 'info',
					title: 'No gift cards available. Please select a different country.',
					showConfirmButton: false,
					timer: 3000,
				});
				return;
			}
		}
	};
};

//merchant data
export const fetchVendorDetails = () => {
	return async (dispatch, getState) => {
		let token = (() => {
			try {
				const tokenData = JSON.parse(
					localStorage.getItem('token_gen1') ||
						localStorage.getItem('token_gen'),
				);
				return tokenData?.access_token ? tokenData?.access_token : '';
			} catch {
				return '';
			}
		})();
		const valid = await isTokenExpired(token);
		try {
			if (!valid)
				await getNewAuthToken().then((res) => {
					localStorage.getItem('token_gen1')
						? localStorage.setItem(
								'token_gen1',
								JSON.stringify(res),
						  )
						: localStorage.setItem(
								'token_gen',
								JSON.stringify(res),
						  );
					token = res.access_token;
				});
			const res = await axios.get(
				`fetchVendorDetails?merchantCode=${
					sessionStorage.getItem('usermerchcode') ||
					localStorage.getItem('merchantcode')
				}`,
				{
					headers: {
						Authorization: 'Bearer ' + token,
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				},
			);

			return res.data;
		} catch (err) {
			console.info({ err });
		}
	};
};

//updateMerchantGiftcards
export const updateMerchantGiftcards = (formData) => {
	return async (dispatch, getState) => {
		try {
			const res = await api.post('updateMerchantGiftcards', formData);
			return res.data;
		} catch (err) {
			console.info({ err });
		}
	};
};

//update exiting cart value
export const updateExitingCartItem = (formData) => {
	return async (dispatch, getState) => {
		try {
			const res = await api.post('updateExitingCartItem', formData);
		} catch (err) {
			errToast(err);
		}
	};
};

//addToCart
export const addToCart = (formData) => {
	return async (dispatch, getState) => {
		try {
			const res = await api.post('addToCart', formData);

			const cartData = res?.data?.data;

			if (cartData?.code) {
				const encryptedCode = encrypt(cartData.code);
				const existingCode = sessionStorage.getItem('cartCode');

				if (!existingCode || existingCode !== encryptedCode) {
					sessionStorage.setItem('cartCode', encryptedCode);
				}
			}
		} catch (err) {
			errToast(err);
		}
	};
};

const mapProductToLocalCard = (product, existingItem) => {
	const quantity = Number(product.quantity || 0);
	const fixValue = Number(product.denomination || 0);
	const discount = Number(product.discount_percentage || 0);
	const total = fixValue * quantity;
	const savings = (total * discount) / 100;
	const discountedValue = total - savings;

	return {
		fix_value: fixValue,
		price_type: 'fixed',
		quantity,
		total,
		savings,
		discount,
		discountedValue,
		code: product.product_code,
		name: product.name,
		image: product.image || '',
		currencySymbol: '₹',
		category: null,
		vendor_id: product.vendor_code,
		merchantName: 'razorpay gc',
		quanErr: false,

		// 🔹 keep id ONLY if already present
		...(existingItem?.id ? { id: existingItem.id } : {}),

		// 🔹 missing / extra keys from API
		delivery_charge: Number(product.delivery_charge || 0),
		// item_type: product.item_type,
		// max_quantity: product.max_quantity,
		// sender_name: product.sender_name,
		// receiver_name: product.receiver_name,
		// receiver_email: product.receiver_email,
		// receiver_mobile: product.receiver_mobile,
		// message: product.message,
		// gift_card_image: product.gift_card_image,
	};
};

const setCartItemCount = (cardArray = []) => {
	const count = cardArray.filter((i) => Number(i.total) > 0).length;
	localStorage.setItem('cartItem', String(count));
};

// const syncLocalCartWithApi = (productsList = []) => {
// 	const existingCard = localStorage.getItem('card')
// 		? JSON.parse(decrypt(localStorage.getItem('card')))
// 		: [];

// 	const existingMap = new Map(existingCard.map((item) => [item.code, item]));

// 	const updatedCard = productsList.map((product) =>
// 		mapProductToLocalCard(product, existingMap.get(product.product_code)),
// 	);

// 	localStorage.setItem('card', encrypt(JSON.stringify(updatedCard)));

// 	// ✅ SET cartItem count
// 	setCartItemCount(updatedCard);
// };

const syncLocalCartWithApi = (productsList = []) => {
	const existingCard = localStorage.getItem('card')
		? JSON.parse(decrypt(localStorage.getItem('card')))
		: [];

	const existingMap = new Map(existingCard.map((item) => [item.code, item]));

	// 🔥 API is the source of truth
	const updatedCard = productsList.map((product) =>
		mapProductToLocalCard(product, existingMap.get(product.product_code)),
	);

	// Empty API cart → clear local cart
	if (!updatedCard.length) {
		localStorage.removeItem('card');
		localStorage.removeItem('cartItem');
		return;
	}

	localStorage.setItem('card', encrypt(JSON.stringify(updatedCard)));
	setCartItemCount(updatedCard);
};

export const getCartDetails = (formData) => {
	return async (dispatch) => {
		try {
			const res = await api.get(buildQuery('cartDetails', formData));

			const cartData = res?.data?.data;

			// 🔹 Store cartCode
			if (cartData?.code) {
				const encryptedCode = encrypt(cartData.code);
				const existingCode = sessionStorage.getItem('cartCode');

				if (!existingCode || existingCode !== encryptedCode) {
					sessionStorage.setItem('cartCode', encryptedCode);
				}
			} else {
				sessionStorage.removeItem('cartCode');
			}

			// 🔹 Sync localStorage card
			if (cartData?.products_list?.length) {
				syncLocalCartWithApi(cartData.products_list);
			} else {
				//  Cart empty
				localStorage.removeItem('card');
				localStorage.removeItem('cartItem');
			}
			return res?.data?.data;
		} catch (err) {
			errToast(err);
		}
	};
};

//getCartDetails
// export const getCartDetails = (formData) => {
// 	return async (dispatch, getState) => {
// 		try {
// 			const res = await api.get(buildQuery('cartDetails', formData));
// 			console.info({ res });
// 			if (res?.data?.data?.code)
// 				sessionStorage.setItem(
// 					'cartCode',
// 					encrypt(res?.data?.data?.code),
// 				);
// 		} catch (err) {
// 			errToast(err);
// 		}
// 	};
// };

//Place order of Product
export const orderProduct = (formData) => {
	return async (dispatch, getState) => {
		try {
			const res = await api.post('productOrdered', formData);
			const {
				data: { success, message },
			} = res;
			let obj = {
				success: success,
				message: message,
			};
			return obj;
		} catch (err) {
			errToast(err);
			return {
				success: false,
				message: '',
			};
		}
	};
};

// remove cartItem
export const removeCartItem = (formData) => {
	return async (dispatch, getState) => {
		try {
			const res = await api.post('removeCartItem', {
				...formData,
				cart_code: decrypt(sessionStorage.getItem('cartCode')),
			});
			return res.data;
		} catch (err) {
			errToast(err);
		}
	};
};

// clear cart
export const clearCart = (t) => {
	return async (dispatch, getState) => {
		// const cart_code = getState().addToCart.cart_code;
		try {
			const res = await api.post('clearCart', {
				cart_code: decrypt(sessionStorage.getItem('cartCode')),
			});
			// toast.success(
			// 	t(`All items have been successfully removed from your cart.`),
			// );
		} catch (err) {
			errToast(err);
		}
	};
};

//saveOrder
export const saveOrder = (formData) => {
	return async (dispatch, getState) => {
		try {
			const res = await api.post('saveOrder', formData);
			return res.data.data.id;
		} catch (err) {
			errToast(err);
		}
	};
};

//saveOrder
export const updateOrder = (formData) => {
	return async (dispatch, getState) => {
		try {
			const res = await api.post('updateOrder', formData);
			// return {
			// 	status_code: res.data.status_code,
			// 	message: res.data.message,
			// 	code: res?.data?.data?.code,
			// };
			return {
				...(res?.data?.data || {}),
				status_code: res.data.status_code,
				message: res.data.message,
			};
		} catch (err) {
			errToast(err);
			return err;
		}
	};
};

//giftCardLists
export const getGiftCardLists = (formData) => {
	return async (dispatch) => {
		try {
			const res = await api.get(buildQuery('giftCardLists', formData));

			return res?.data?.data;
		} catch (err) {
			errToast(err);
		}
	};
};
